<div class="accreditation-card bg-success" [ngClass]="slimMode ? 'slim' : 'wide'">
  <img src="https://iili.io/HH2EezN.png" alt="rosette">
  <!-- <i class="fa-solid fa-certificate text-white"></i> -->
  <div class="card-text text-wrap">
    <p class="title text-white"><span *transloco="let t">{{t('tracking.accredited_until')}}</span> {{certification.expired_at | date: 'yyyy'}}</p>
    <p class="subtitle text-white">{{certification.subject?.name}}</p>
  </div>
</div>